// custom-b2b-script.js
console.log("boogy");

setTimeout(() => {
  const inputField = document.querySelector('.vat-validation');
  console.log(inputField);

  // Initialize the variable to hold whether the check is true or not
  let startsWithFR = false;

  // Add an event listener for the input field
  inputField.addEventListener('input', () => {
    // Check if the value starts with 'FR'
    startsWithFR = inputField.value.toUpperCase().startsWith('FR');

    // Log the value of the 'startsWithFR' variable
    console.log('startsWithFR:', startsWithFR);

    // Update BSS_B2B.taxExempt based on the startsWithFR value
    if (startsWithFR) {
      BSS_B2B.taxExempt = 0;
    } else {
      BSS_B2B.taxExempt = 1;
    }
  });
}, 500);
